import { render, staticRenderFns } from "./coachClassesList.vue?vue&type=template&id=97d5ed40&scoped=true&"
import script from "./coachClassesList.vue?vue&type=script&lang=js&"
export * from "./coachClassesList.vue?vue&type=script&lang=js&"
import style0 from "./coachClassesList.vue?vue&type=style&index=0&id=97d5ed40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d5ed40",
  null
  
)

export default component.exports